const s={values:{xs:0,sm:768,md:968,lg:1200,xl:1536}};export{s as default};
//# sourceMappingURL=base-breakpoints.js.map
